import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminUserRoutes extends RouteBase {
  prefix = ROUTE_PREFIX + 'users.'

  index() {
    return this.ziggyRoute('index')
  }

  store() {
    return this.ziggyRoute('store')
  }

  show(userId: number) {
    return this.ziggyRoute('show', userId)
  }

  updateUserInfo(userId: number) {
    return this.ziggyRoute('update_user_info', userId)
  }

  updatePassword(userId: number) {
    return this.ziggyRoute('update_password', userId)
  }

  wallet(userId: number) {
    return this.ziggyRoute('wallet', userId)
  }

  walletUpdate(userId: number) {
    return this.ziggyRoute('wallet_update', userId)
  }

  updateBankInfo(userId: number) {
    return this.ziggyRoute('update_bank_info', { user: userId, _method: 'put' })
  }

  updateAccessibility(userId: number) {
    return this.ziggyRoute('update_accessibility', userId)
  }

  switchToUser(userId: number) {
    return this.ziggyRoute('switch_to_user', userId)
  }

  updateBillingInfo(userId: number) {
    return this.ziggyRoute('update_billing_info', userId)
  }

  infoComponent(user: number) {
    return this.ziggyRoute('info_component', user)
  }

  updateSetting(userId: number) {
    return this.ziggyRoute('update_settings', userId)
  }

  exportExcel() {
    return this.ziggyRoute('export')
  }
}

@vsingleton()
export class AdminUserApiRoutes extends RouteBase {
  prefix = ROUTE_PREFIX + 'api.'

  userSearch() {
    return this.ziggyRoute('user_search')
  }
}
